// CallDetailsForm.tsx
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Slider } from "@/components/ui/slider";
import { Spinner } from "@/components/ui/spinner";

interface CallDetailsFormProps {
  callDescription: string;
  setCallDescription: (value: string) => void;
  callDuration: number;
  setCallDuration: (value: number) => void;
  strategyType: string;
  setStrategyType: (value: string) => void;
  onGeneratePrompts: () => void;
  loading: boolean;
}

export const CallDetailsForm = ({
  callDescription,
  setCallDescription,
  callDuration,
  setCallDuration,
  strategyType,
  setStrategyType,
  onGeneratePrompts,
  loading,
}: CallDetailsFormProps) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>Call Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col min-w-0 gap-4 mb-4">
          <div className="col-span-1 md:col-span-2">
            <Textarea
              value={callDescription}
              onChange={(e) => setCallDescription(e.target.value)}
              placeholder="Enter call description"
              className="w-full h-32"
            />
          </div>
          <div>
            <label className="block mb-2">
              Call Duration: {callDuration} minutes
            </label>
            <Slider
              value={[callDuration]}
              onValueChange={(value) => setCallDuration(value[0])}
              max={30}
              step={1}
            />
          </div>
          <div>
            <label className="block mb-2">Strategy Type</label>
            <Input
              value={strategyType}
              onChange={(e) => setStrategyType(e.target.value)}
              placeholder="Enter strategy type (e.g., appointment reminder)"
            />
          </div>
        </div>
        <Button onClick={onGeneratePrompts} disabled={loading}>
          {loading ? <Spinner /> : "Generate Prompts"}
        </Button>
      </CardContent>
    </Card>
  );
};
